export default "__VITE_ASSET__DoVuei2e__"